import React from 'react'

export default function FacilityLoader({ isDarkMode, label = 'Loading facility data' }) {
	const spinnerColor = isDarkMode ? '#38bdf8' : '#3b82f6'

	return (
		<div className="flex justify-center py-8" role="status" aria-label={label}>
			<span
				className="loading loading-spinner loading-md"
				style={{
					color: spinnerColor,
					width: '36px',
					height: '36px',
				}}
			/>
		</div>
	)
}
